import ResultPage from '@/components/Result/index';
import { useLocation } from '@/lib/router-dom/index';

const ApprovalTransactionSuccessPage = () => {

    const { currentState } = useLocation();
    const type = currentState?.type;
    const transactionRequestId = currentState?.transactionRequestId;
    const transferableRecordId = currentState?.transferableRecordId;

	const breadcrumbsItem = [
		{
			label: '',
			link: '/'
		 },
		{
			label: 'Approvals',
			link: '/approvals'
		}
	]

    return ResultPage({
		layoutHeaderTxt: type,
        layoutContentImgPath: "/img/theme-success.png",
        backBtnTxt: 'Back to Approval Page',
        breadcrumbs: breadcrumbsItem,
        nextLocation: '/approvals',
        viewRecordLocation: `/approvals/transaction/${transactionRequestId}/${transferableRecordId}`,
        viewETRRecord: true,
        viewETRButtontext: 'View Request',
	});

}
export default ApprovalTransactionSuccessPage
